<template>
  <div>
    <b-navbar type="green" toggleable>
      <div class="container">
        <b-navbar-brand><img src="img/header-title.svg" alt=""></b-navbar-brand>
      </div>
    </b-navbar>
  </div>
</template>


<script>
  export default {
    name: 'quiz-header'
  }
</script>


<style lang="scss">
  .navbar-brand{
    img{
      max-width:260px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/QuizHeader.vue